import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';
import { IconLockOutline } from '@zillow/constellation';

export const ZestimateContainer = styled.div`
  padding: 16px;
  background: white;
  font-weight: 600;
  width: 100%;
  margin-top: 24px;

  ${mediaMixin(
    'md',
    css`
      width: 350px;
      margin: 0;
    `,
  )};
`;

export const ClaimHomeContainer = styled.section`
  display: flex;
`;

export const IconLock = styled(IconLockOutline)`
  content: '';
  font-size: 21px;
  margin-right: 4px;
`;

export const PriceText = styled.div`
  cursor: pointer;
  display: inline-block;
`;
